import * as serializers from "serializers/legacy/legacy-glTF2Serializer";
export { serializers };
export default serializers;
